/**
 * KIS Routing Utility
 *
 * Handles routing for KIS across different domains:
 * - kis.kausora.com → Clean URLs (e.g., /dashboard)
 * - kausora.com → Prefixed URLs (e.g., /kis/dashboard)
 */

/**
 * Check if we're on the KIS subdomain
 */
export const isKISDomain = () => {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  return hostname.includes('kis.kausora.com') || hostname.includes('kis.localhost');
};

/**
 * Get the appropriate KIS route path
 * @param {string} path - The path without /kis prefix (e.g., '/dashboard' or 'dashboard')
 * @returns {string} - The full path with /kis prefix if needed
 */
export const getKISRoute = (path) => {
  // Ensure path starts with /
  const cleanPath = path.startsWith('/') ? path : `/${path}`;

  // Remove /kis prefix if it exists (normalize the input)
  const normalizedPath = cleanPath.replace(/^\/kis/, '');
  const finalPath = normalizedPath || '/';

  // If on KIS subdomain, use clean URLs
  if (isKISDomain()) {
    return finalPath;
  }

  // Otherwise, prefix with /kis
  return `/kis${finalPath}`;
};

/**
 * Navigate to a KIS route (works with both domains)
 * @param {Function} navigate - React Router's navigate function
 * @param {string} path - The path without /kis prefix
 * @param {object} options - Navigation options (e.g., { replace: true })
 */
export const navigateToKIS = (navigate, path, options = {}) => {
  navigate(getKISRoute(path), options);
};

/**
 * Get the KIS base URL for external links
 * @returns {string} - The base URL for KIS
 */
export const getKISBaseURL = () => {
  if (typeof window === 'undefined') return '/kis';

  if (isKISDomain()) {
    return window.location.origin;
  }

  return `${window.location.origin}/kis`;
};
